import React from "react";
import Lucky9 from "../../../assets/img/lucky9.png";
import { formatBook } from "../../../utils/formatOdds";

const LABELS = ["Winner", "High Card", "Pair", "Color Plus"];

const normalize = (str) => String(str || "").replace(/\s+/g, " ").trim().toLowerCase();

/**
 * 29Card Baccarat (teensin) bet table — reference markup (inside .casino-detail of .casino-table.sin-khal):
 *   .teen20casino-container > .teen20left / .teen20center / .teen20right
 *     (each: .casino-box-row title, .casino-bl-box-title header row, .casino-bl-box odds row)
 *   .sin-khal-box > img(lucky9) + .casino-bl-box (back, lay, .sin-khal-box-book)
 * Markets per reference: filter `sub` by subtype and order by sr ([0] = A, [1] = B).
 * A box is suspended whenever gstatus is not OPEN. Book spans follow the reference v-casinofancybook
 * directive: book-green when > 0 else book-red, and a suspended box with a book gets "lock-top"
 * (tenexch 7955546b: padlock at the top only with a liability; no book → centred).
 */
const BetTableTeensin = ({ data = [], onBetClick, exposures = {}, myBets = [] }) => {
  const bySubtype = (subtype) =>
    data.filter((i) => i?.subtype === subtype).sort((a, b) => (Number(a?.sr) || 0) - (Number(b?.sr) || 0));

  const player = bySubtype("teensin");
  const highCard = bySubtype("highcard");
  const pair = bySubtype("pair");
  const colorPlus = bySubtype("colorplus");
  const lucky9 = bySubtype("lucky9")[0] || {};

  const isSuspended = (item) => String(item?.gstatus || "").toUpperCase() !== "OPEN";

  // Downline exposure for a market: My Bets entry first, then the exposure map (by nat)
  const getExposure = (selection, betType = "back") => {
    if (!selection) return 0;
    const sel = normalize(selection);
    const bet = myBets.find((b) => {
      const bs = normalize(b.selection || b.matchedBet || b.player_name || "");
      const bt = String(b.type || "").toLowerCase();
      return bs && (bs === sel || bs.includes(sel) || sel.includes(bs)) && (bt === betType || bt === "");
    });
    if (bet && bet.exposer) return parseFloat(bet.exposer) || 0;
    for (const key of [selection, `${selection} ${betType}`, `${selection} ${betType.toUpperCase()}`, sel]) {
      const v = parseFloat(exposures[key]);
      if (Number.isFinite(v) && v !== 0) return v;
    }
    return 0;
  };

  const book = (selection) => {
    const exp = getExposure(selection);
    return { cls: exp > 0 ? "book-green" : "book-red", text: formatBook(exp) };
  };

  const click = (item, value, type) => {
    if (isSuspended(item) || !value || !onBetClick) return;
    onBetClick(value, item?.nat || "", item, type);
  };

  const oddsBox = (item) => {
    const locked = isSuspended(item);
    const bk = book(item?.nat);
    return (
      <div
        className={`back casino-bl-box-item${locked ? (getExposure(item?.nat) ? " suspended lock-top" : " suspended") : ""}`}
        onClick={() => click(item, item?.b, "back")}
      >
        <span className="casino-box-odd">{item?.b}</span> <span className={bk.cls}>{bk.text}</span>
      </div>
    );
  };

  const side = (cls, titleCls, title, idx) => (
    <div className={cls}>
      <div className="casino-box-row">
        <div className="casino-nation-name no-border casino-bl-box-title">
          <div className={titleCls}>{title}</div>
        </div>
      </div>{" "}
      <div className="casino-bl-box casino-bl-box-title d-none-small">
        {LABELS.map((l, i) => (
          <React.Fragment key={l}>
            {i > 0 && " "}
            <div className="casino-bl-box-item">
              <span>{l}</span>
            </div>
          </React.Fragment>
        ))}
      </div>{" "}
      <div className="casino-bl-box">
        {[player, highCard, pair, colorPlus].map((list, i) => (
          <React.Fragment key={LABELS[i]}>
            {i > 0 && " "}
            <div className="casino-bl-box-item d-none-big">
              <span>{LABELS[i]}</span>
            </div>{" "}
            {oddsBox(list[idx] || {})}
          </React.Fragment>
        ))}
      </div>
    </div>
  );

  const l9Locked = isSuspended(lucky9);
  const l9Book = book(lucky9?.nat || "Lucky 9");

  return (
    <>
      <div className="teen20casino-container">
        {side("teen20left", "playera", "Player A", 0)} <div className="teen20center" />{" "}
        {side("teen20right", "playerb", "Player B", 1)}
      </div>{" "}
      <div className="sin-khal-box">
        <img src={Lucky9} alt="" />{" "}
        <div className="casino-bl-box">
          <div
            className={`back casino-bl-box-item${l9Locked ? " suspended" : ""}`}
            onClick={() => click({ ...lucky9, type: "back", value: lucky9?.b, selection: lucky9?.nat, back: lucky9?.b, lay: lucky9?.l }, lucky9?.b, "back")}
          >
            <span className="casino-box-odd">{lucky9?.b}</span>
          </div>{" "}
          <div
            className={`lay casino-bl-box-item${l9Locked ? " suspended" : ""}`}
            onClick={() => click({ ...lucky9, type: "lay", value: lucky9?.l, selection: lucky9?.nat, back: lucky9?.b, lay: lucky9?.l }, lucky9?.l, "lay")}
          >
            <span className="casino-box-odd">{lucky9?.l}</span>
          </div>{" "}
          <div className={`sin-khal-box-book ${l9Book.cls}`}>{l9Book.text}</div>
        </div>
      </div>
    </>
  );
};

export default BetTableTeensin;
